"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
exports.overlayText = {
    bottom: 15,
    color: "white",
    left: 30,
    position: "absolute"
};
exports.overlayFull = {
    backgroundColor: "none",
    color: "white",
    height: "100vh",
    left: 0,
    opacity: 1,
    position: "fixed",
    top: 0,
    width: "100vw",
    zIndex: 10000
};
exports.overlay = {
    backgroundColor: "rgba(0, 0, 0, 0.37)",
    color: "white",
    height: "100vh",
    left: 0,
    opacity: 0.8,
    position: "fixed",
    top: 0,
    width: "100vw",
    zIndex: 10000
};
exports.lightboxStyle = {
    height: "100vh",
    opacity: 1,
    position: "fixed",
    width: "100%",
    zIndex: 11000
};
exports.sectionStyle = {
    alignItems: "center",
    color: "white",
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    justifyContent: "center",
    position: "relative",
    width: "100%",
    zIndex: 11000,
    WebkitOverflowScrolling: "touch",
    overflowY: "auto"
};
exports.closeButton = {
    backgroundColor: "none",
    color: "white",
    cursor: "pointer",
    fontSize: 50,
    position: "absolute",
    right: 50,
    top: 30
};
exports.backgroundOverlay = {
    backgroundColor: "black",
    height: "150vh",
    opacity: 0.8,
    position: "absolute",
    top: 0,
    width: "100%",
    zIndex: -1
};
exports.ModalContainer = styled_components_1.default.div `
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  overflow: hidden;
`;
exports.PopupContainer = styled_components_1.default.div `
  justify-content: center;
  align-items: center;
  height: 100%
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`;
exports.HelpImage = styled_components_1.default.img `
  position: absolute;
  top: 0;
  width: 87vw;
`;
exports.Row = styled_components_1.default.div `
  position: relative;
  justify-content: center;
  align-items: center;
  display: flex;
  z-index: 1;
  margin-bottom: 10vh;
`;
exports.ImageRow = styled_components_1.default(exports.Row) `
  width: 100%;
  height: calc((483 / 327) * 87vw);
  max-height: 75vh;
  overflow-y: scroll;
`;
exports.CloseButtonContainer = styled_components_1.default(exports.Row) `
  position: fixed;
  bottom: 7vh;
  margin-bottom: 0px;
`;
exports.CloseButton = styled_components_1.default.img `
  margin-top: 3vh;
  width: 100%;
  max-width: 40px;
  align-self: flex-end;
`;
//# sourceMappingURL=ModalStyle.js.map